import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=26abce88&scoped=true&"
import script from "./Clinic.vue?vue&type=script&lang=js&"
export * from "./Clinic.vue?vue&type=script&lang=js&"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=26abce88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26abce88",
  null
  
)

export default component.exports